import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import SideBarRecursive from "../Common/SideBarRecursive";
import { sideBarItems } from "../constants/sidebarItems";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import logoImage from "../../assets/media/image/logo-property-nexus-removebg-preview.png";
import { useDispatch } from "react-redux";
import { setManagerAccessList } from "../../Redux/Slice/ManagerSlice";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faCog, faSignOutAlt, faBell, faDashboard } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@mui/material";
import { baseUrlLms } from "../../Redux/BaseUrl/baseurl";


function MenuAppBarWithDrawer() {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);


  const selectedImage = localStorage.getItem("selectedImage");
  const capturedImage = localStorage.getItem("capturedImage");
  const accessedMenuList = localStorage.getItem("accessedMenuList");

  const [selectedImg, setSelectedImg] = useState("");
  const [capturedImg, setCapturedImg] = useState("");

  const handleLogout = () => {
    localStorage.clear();
    navigate("/")
  };

  const handleRedirectClick = () => {
    const redirectURL = `${baseUrlLms}/login/validate_login?email=proptechadmin@gmail.com`;
    window.location.href = redirectURL;
    // window.open(redirectURL, '_blank'); // Opens the URL in a new tab
  };


  useEffect(() => {

    if (selectedImage) {
      setSelectedImg(selectedImage);
    }
    if (capturedImage) {
      setCapturedImg(capturedImage);
    }
    if (accessedMenuList) {
      dispatch(setManagerAccessList(accessedMenuList));
    }

  }, []);

  const handleMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };


  // const toggleDrawer = (open) => (event) => {
  //   console.log("Drawer state before:", drawerOpen);
  //   if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
  //     return;
  //   }
  //   setDrawerOpen(open);
  //   console.log("Drawer state after:", open);
  // };


  return (
    <>

      <AppBar position="sticky" sx={{ backgroundColor: "#1c4d6b" }}>
        <Toolbar>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={()=>setDrawerOpen(!drawerOpen)}
          >
            <MenuIcon />
          </IconButton> */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link to="/" >
              <img src={logoImage} alt="Property Search"
                height={60}
                width={170}
              />
            </Link>
          </Typography>
          {auth && (
            <div>
              <Button

                onClick={() => handleRedirectClick()}
                variant="contained"
                style={{
                  backgroundColor: "#e1777d",
                  marginRight: "10px",
                }}
              >
                <FontAwesomeIcon
                  icon={faDashboard}
                  style={{ color: "white" }}
                />
                &nbsp;&nbsp; LMS Dashboard
              </Button>

              <Link
                to="/investor/notifications"
                // className="btn nav-link"
                title="Notification"
                data-toggle="tooltip"
              >
                <FontAwesomeIcon color="white" icon={faBell} size="lg" style={{ marginTop: 4, marginRight: 3 }} />
              </Link>

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                sx={{ mt: '45px', p: 5 }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >

                <MenuItem >
                  <Link
                    to="/profile"
                    // className="btn nav-link bg-info-bright"
                    title="Profile"
                    data-toggle="tooltip"
                  >
                    <FontAwesomeIcon icon={faUser} style={{ marginTop: 4, marginRight: 3 }} /> Profile
                  </Link>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  < Typography>
                    <FontAwesomeIcon
                      icon={faSignOutAlt}
                      style={{ marginTop: 4, marginRight: 3 }}
                    /> Logout
                  </Typography>
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        anchor="left"
        open={drawerOpen}
        sx={{ width: 250, flexShrink: 0, [`& .MuiDrawer-paper`]: { width: 250, marginTop: "64px" } }}
      >
        {SideBarRecursive(sideBarItems)}
      </Drawer>
    </>
  );
}

export default MenuAppBarWithDrawer;